// 지도 핀 선택 — **이번 범위는 플레이스홀더**. 웹에는 아직 지도 SDK 가 없어서
// 앱 MapLocationPickScreen 대신 주소/좌표 텍스트 입력 폴백을 둔다(서버 location 은 문자열만 저장).
// 후속: 카카오맵 JS SDK 도입 시 이 모달 본문만 교체하면 된다(계약 = onPick(문자열)).
import React, { useEffect, useState } from 'react';
import { T, R } from '../../../theme';
import { SheetFrame } from '../../parts/ConfirmSheet';
import { input, NoteBox, btnNavy, btnPlain } from './bits';

var mapBox = { height: 140, borderRadius: R.md, border: '1px dashed ' + T.line, background: T.head,
  display: 'grid', placeItems: 'center', color: T.faint, fontSize: 12 };
var row = { display: 'flex', gap: 10 };

function MapPickModal(props) {
  var t = props.t;
  var st = useState(props.initial || '');
  var value = st[0], setValue = st[1];
  var open = props.open, initial = props.initial;
  // 열 때마다 현재 검차 위치로 되맞춘다 (모달은 닫혀도 마운트된 채 남는다).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(function () { if (open) setValue(initial || ''); }, [open, initial]);
  if (!open) return null;
  return (<SheetFrame open title={t('inspectorMapPickTitle')} onClose={props.onClose} closeLabel={t('actionClose')}>
    <div style={mapBox} aria-hidden="true">{t('inspectorMapPickMyLocation')}</div>
    <input style={input} value={value} placeholder={t('evalFormLocationHint')} aria-label={t('evalFormLocation')}
      onChange={function (e) { setValue(e.target.value); }} />
    <NoteBox><div>{t('simpleSchedNote')}</div></NoteBox>
    <div style={row}>
      <button type="button" style={Object.assign({}, btnPlain, { flex: 1 })} onClick={props.onClose}>{t('actionClose')}</button>
      <button type="button" style={Object.assign({}, btnNavy, { flex: 2 })} data-testid="map-confirm"
        onClick={function () { props.onPick(value.trim()); }}>{t('inspectorMapPickConfirm')}</button>
    </div>
  </SheetFrame>);
}

export default MapPickModal;
